import { IconProps } from '@/components/Icon';

export const IconORYXGO = ({ width = 14, height = 16, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} viewBox='0 0 14 16' width={width} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M12.52,3.43h0S7.12.19,7.12.19c-.02-.01-.03-.02-.05-.03l-.08-.05h-.02c-.14-.07-.3-.11-.47-.11s-.33.04-.47.11h-.01s-.08.05-.08.05c-.02.01-.04.02-.05.03L.5,3.43h0c-.3.2-.49.53-.49.91v6.51c0,.39.21.73.52.92h0s5.37,3.23,5.37,3.23c0,0,0,0,0,0h0s0,0,0,0c.17.11.38.18.6.18s.42-.07.6-.18h0s0,0,0,0c0,0,0,0,0,0l5.37-3.22h0c.31-.2.52-.54.52-.93v-6.51c0-.38-.2-.71-.49-.91h0ZM6.24,7.87c-.32.37-.88.59-1.62.59-1.18,0-1.91-.53-1.91-1.5s.73-1.5,1.91-1.5c.7,0,1.21.22,1.52.5l-.68.51c-.25-.2-.47-.28-.8-.28-.63,0-.95.28-.95.76s.33.77.96.77c.27,0,.48-.05.67-.18v-.23h-.81v-.62h1.72v1.16ZM6.56,6.97c0-.96.75-1.5,1.87-1.5s1.87.54,1.87,1.5-.75,1.5-1.87,1.5-1.87-.54-1.87-1.5ZM9.31,6.97c0-.46-.33-.73-.88-.73s-.88.27-.88.73.33.73.88.73.88-.27.88-.73Z'
        fill={color}
        fillRule='evenodd'
      />
    </svg>
  );
};
